<template>
  <component :is="foundraisingData === undefined ? 'div' : 'b-card'">
    <!-- Alert: No Foundraising found -->
    <b-alert variant="danger" :show="foundraisingData === undefined">
      <h4 class="alert-heading">Erreur lors de chargement du contenu</h4>
      <div class="alert-body">
        Aucun element trouvé avec cet identifiant. Vérifier
        <b-link class="alert-link" :to="{ name: 'foundraising-list' }">
          Liste des elements
        </b-link>
        pour les autres element.
      </div>
    </b-alert>

    <data-add-tab
      :foundraising-data="foundraisingData"
      :defaultfoundraising-data="defaultfoundraisingData"
      class="mt-2"
    />
  </component>
</template>

<script>
import {
  BTab,
  BTabs,
  BCard,
  BRow,
  BCol,
  BAlert,
  BLink,
  BFormCheckbox,
  BButton,
} from "bootstrap-vue";
import { ref, onUnmounted } from "@vue/composition-api";
import router from "@/router";
import store from "@/store";
import storeModule from "./storeModule";
import DataAddTab from "./FormData.vue";
import Ripple from "vue-ripple-directive";

export default {
  components: {
    BTab,
    BTabs,
    BCard,
    BRow,
    BCol,
    BAlert,
    BLink,
    BFormCheckbox,
    DataAddTab,
    BButton,
    // DataAddTabInformation,
    // DataAddTabSocial,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      operationTitle: "",
      operationIcon: "",
    };
  },
  mounted() {
    if (router.currentRoute.name == "foundraising-add-new") {
      this.operationTitle = "Ajouter Foundraising";
      this.operationIcon = "AddIcon";
    }
    if (router.currentRoute.name == "foundraising-view") {
      this.operationTitle = "Détails de l'Foundraising";
      this.operationIcon = "EyeIcon";
    }
    if (router.currentRoute.name == "foundraising-edit") {
      this.operationTitle = "Modification de l'Foundraising";
      this.operationIcon = "EditIcon";
    }
  },
  methods: {
    prevPage() {
      router.push({ name: "foundraising-list" });
    },
    convertBoolToInt(value) {
      if (value == 1) {
        return true;
      } else {
        return false;
      }
    },
  },
  setup() {
    let foundraisingData = ref(null);
    let APP_STORE_MODULE_NAME = "app-foundraising";

    // Register module
    if (!store.hasModule(APP_STORE_MODULE_NAME))
      store.registerModule(APP_STORE_MODULE_NAME, storeModule);

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(APP_STORE_MODULE_NAME))
        store.unregisterModule(APP_STORE_MODULE_NAME);
    });

    var defaultfoundraisingData = ref({
      bank: "",
      cheque: "",
      amount: "",
      currency: "", 
      beneficiary_ref: "", 
      date: "", 
      notes: "", 
    }); 

    if (router.currentRoute.name == "foundraising-add-new") {
      // init empty foundraising data
      foundraisingData = defaultfoundraisingData;
    } else {
      // requirement //
      store
        .dispatch(APP_STORE_MODULE_NAME + "/fetchModule", {
          id: router.currentRoute.params.id,
        })
        .then((response) => {
          foundraisingData.value = response.data;
        })
        .catch((error) => {
          console.log(error);
          foundraisingData.value = undefined;
        });
    }

    return {
      foundraisingData,
      defaultfoundraisingData,
    };
  },
};
</script>
